export enum FaerbungReviewCategories {
  'sensitivity' = 1,
  'specificity' = 2,
}

interface FaerbungCategoryPayload {
  category: FaerbungReviewCategories;
  score: number;
}

export interface FaerbungReviewMeta {
  id: number;
  digitalSurveyId: number;
  digitalSectionId: number;
  passingScore: number;
  maxScore: number;
  categories: FaerbungCategoryPayload[];
}

export interface FaerbungReviewScore {
  id: number;
  digitalSurveyId: number;
  digitalSectionId: number;
  digitalCaseId: number;
  enrollmentId: number;
  categoryScore: FaerbungCategoryPayload[];
  score: number;
}

export interface FaerbungReviewState {
  faerbungReviewMeta: {
    byId?: Record<number, FaerbungReviewMeta>;
    allIds?: number[];
  }
  faerbungReviewScore: {
    byId: Record<number, FaerbungReviewScore>;
    allIds: number[];
  }
}

/** Redux Action Constants */
export const SET_FAERBUNG_REVIEW_METAS = 'SET_FAERBUNG_REVIEW_METAS';
export const ADD_UPDATE_FAERBUNG_REVIEW_META = 'ADD_UPDATE_FAERBUNG_REVIEW_META';
export const RESET_FAERBUNG_REVIEW_META = 'RESET_FAERBUNG_REVIEW_META';
export const DELETE_FAERBUNG_REVIEW_META = 'DELETE_FAERBUNG_REVIEW_META';
export const SET_FAERBUNG_REVIEW_SCORE = 'SET_FAERBUNG_REVIEW_SCORE';
export const ADD_UPDATE_FAERBUNG_REVIEW_SCORE = 'ADD_UPDATE_FAERBUNG_REVIEW_SCORE';

interface SetFaerbungReviewMetaAction {
  type: typeof SET_FAERBUNG_REVIEW_METAS;
  payload: FaerbungReviewMeta[];
}

interface AddUpdateFaerbungReviewMetaAction {
  type: typeof ADD_UPDATE_FAERBUNG_REVIEW_META;
  payload: FaerbungReviewMeta[];
}

interface ResetFaerbungReviewMetaAction {
  type: typeof RESET_FAERBUNG_REVIEW_META;
}

interface DeleteFaerbungReviewMetaAction {
  type: typeof DELETE_FAERBUNG_REVIEW_META;
  payload: number;
}

interface SetFaerbungReviewScoreAction {
  type: typeof SET_FAERBUNG_REVIEW_SCORE;
  payload: FaerbungReviewScore[];
}

interface AddUpdateFaerbungReviewScoreAction {
  type: typeof ADD_UPDATE_FAERBUNG_REVIEW_SCORE;
  payload: FaerbungReviewScore;
}

export type FaerbungReivewActionTypes = SetFaerbungReviewMetaAction |
  AddUpdateFaerbungReviewMetaAction | ResetFaerbungReviewMetaAction |
  DeleteFaerbungReviewMetaAction | SetFaerbungReviewScoreAction |
  AddUpdateFaerbungReviewScoreAction;
